import { Route, Routes, Navigate } from 'react-router-dom';
import React, { Fragment, lazy } from 'react';
import AuthGuard from './authentication/AuthGuard';
import Dashboard from './pages/Dashboard';
import GuestGuard from './authentication/GuestGuard';
import AppLayout from './containers/AppLayout';
import SearchLayout from './containers/SearchLayout';
import ScrollToTop from './components/ScrollToTop';
import Orders from './pages/Orders';
import OrderDetails from './pages/Orders/Details';
import Account from './pages/Account';
import ProductDetails from './pages/Products/Details';
import Impersonate from './pages/Account/Impersonate';
import Products from './pages/Products';
import ContactUs from './pages/ContactUs';
import Search from './pages/Search';
import { RouteNames } from './constants/Routes';
import SilentRenewOidc from './authentication/silent-renew-oidc';
import SignInOidc from './authentication/signin-oidc';
import SignOutOidc from './authentication/signout-oidc';

export const renderRoutes = (routes = []) => (
	<ScrollToTop>
		<Routes>
			{routes.map((route) => {
				const Guard = route.guard || Fragment;
				const Layout = route.layout || Fragment;
				const Component = route.component;

				return (
					<Route
						key={route.path || Math.random()}
						path={route.path}
						exact={route.exact}
						element={
							<Guard>
								<Layout>
									{route.routes ? (
										renderRoutes(route.routes)
									) : (
										<Component
											namespace={route.namespace}
											path="/:locale(en|pt)"
										/>
									)}
								</Layout>
							</Guard>
						}
					/>
				);
			})}
		</Routes>
	</ScrollToTop>
);

const routes = [
	{
		exact: true,
		path: RouteNames.ACCESS_REQUIRED,
		component: lazy(() => import('./pages/AccessRequired')),
		guard: GuestGuard,
		namespace: 'access_required',
	},
	{
		exact: true,
		path: RouteNames.MAINTENANCE,
		component: lazy(() => import('./pages/Maintenance')),
		guard: GuestGuard,
		namespace: 'maintenance',
	},
	{
		exact: true,
		path: RouteNames.NOT_FOUND,
		component: lazy(() => import('./pages/NotFound')),
		guard: GuestGuard,
		namespace: 'notFound',
	},
	{
		exact: true,
		path: RouteNames.SIGNIN,
		component: SignInOidc,
	},
	{
		exact: true,
		path: RouteNames.SIGNOUT,
		guard: GuestGuard,
		component: SignOutOidc,
	},
	{
		exact: true,
		path: RouteNames.SILENT_RENEW,
		component: SilentRenewOidc,
	},
	{
		exact: true,
		path: RouteNames.SEARCH,
		guard: AuthGuard,
		layout: SearchLayout,
		component: Search,
		namespace: 'search',
	},

	{
		path: '*',
		guard: AuthGuard,
		layout: AppLayout,
		routes: [
			{
				exact: true,
				path: RouteNames.DASHBOARD,
				guard: AuthGuard,
				component: Dashboard,
				namespace: 'dashboard',
			},
			{
				exact: true,
				path: RouteNames.ORDERS,
				state: { isFilterOpen: false },
				guard: AuthGuard,
				component: Orders,
				namespace: 'orders',
			},
			{
				exact: true,
				path: RouteNames.ORDER_DETAILS,
				component: OrderDetails,
				namespace: 'order_details',
			},
			{
				exact: true,
				path: RouteNames.PRODUCTS,
				guard: AuthGuard,
				component: Products,
				namespace: 'products',
			},
			{
				exact: true,
				path: RouteNames.PRODUCT_DETAILS,
				component: ProductDetails,
				namespace: 'product_details',
			},

			{
				exact: true,
				path: RouteNames.ACCOUNT,
				component: Account,
				namespace: 'account',
			},
			{
				exact: true,
				path: RouteNames.CONTACT,
				component: ContactUs,
				namespace: 'contactUs',
			},
			{
				exact: true,
				path: RouteNames.IMPERSONATE,
				component: Impersonate,
				namespace: 'impersonate',
			},
			{
				component: () => (
					<Route
						path="/redirect"
						element={<Navigate to={RouteNames.NOT_FOUND} />}
					/>
				),
			},
			{
				component: () => (
					<Route
						path="/redirect"
						element={<Navigate to={RouteNames.ACCESS_REQUIRED} />}
					/>
				),
			},
			{
				component: () => (
					<Route
						path="/redirect"
						element={<Navigate to={RouteNames.MAINTENANCE} />}
					/>
				),
			},
		],
	},
];

export default routes;
